import React from 'react';

const STYLES = {
  info: 'bg-blue-50 border-blue-300 text-blue-900',
  purple: 'bg-purple-50 border-purple-300 text-purple-900',
  warn: 'bg-amber-50 border-amber-400 text-amber-900',
  new: 'bg-green-50 border-green-300 text-green-900'
};

/** Inline banner used on Beam convert + update contract flows. */
const InfoBanner = ({ variant = 'info', icon, children }) => (
  <div className={`flex gap-3 p-3 rounded-md border-l-4 mb-3 text-sm leading-relaxed ${STYLES[variant] || STYLES.info}`}>
    <span className='font-bold shrink-0'>{icon}</span>
    <div>{children}</div>
  </div>
);

export default InfoBanner;
